import script from "./WCActiveOrderTypeBadgeModern.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCActiveOrderTypeBadgeModern.vue?vue&type=script&setup=true&lang=ts"

import "./WCActiveOrderTypeBadgeModern.vue?vue&type=style&index=0&id=7380b244&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7380b244"]])

export default __exports__